export default __webpack_public_path__ + "static/media/login-bg.ba4c0aa9.jpg";